<template>
  <labeled-form-control label="Neutered" :optional="true">
    <div class="d-flex">
      <input v-model="neuteredId" :value="1" type="radio" :disabled="disabled"/><span class="ml-2">Unknown</span>
      <input v-model="neuteredId" :value="2" type="radio" :disabled="disabled" class="ml-4"/><span class="ml-2">Yes</span>
      <input v-model="neuteredId" :value="3" type="radio" :disabled="disabled" class="ml-4"/><span class="ml-2">No</span>
    </div>
  </labeled-form-control>
</template>

<script>
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetNeutered',
  props: {
    value: Number,
    disabled: Boolean
  },
  computed: {
    neuteredId: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
